/**
 * A flag to override the URL for the ODSP Driver Manifest
 */
export const odspDriverManifestUrl = 'odspDriverManifestUrl';
//# sourceMappingURL=devOverrideKeys.js.map